import React from 'react'
import './index.css'

export const Tips = () => (
    <div style={{ textAlign: 'center' }}>
        <em>Tip: Hold shift when sorting to multi-sort</em>
    </div>
)



// WEBPACK FOOTER //
// ./src/Utils.js